import PropTypes from "prop-types";
import styles from "./LandingProps.module.css";

const LandingProps = ({ className = "" }) => {
  return (
    <section className={[styles.valueGridWrapper, className].join(" ")}>
      <div className={styles.valueGrid}>

        <div className={styles.valueProposition}>
          <div className={styles.valuePropositionChild} />
          <div className={styles.propositionDetails}>
            <h3 className={styles.valueProp1}>Draft date polls</h3>
          </div>
          <img
            className={styles.propositionTitleIcon}
            loading="lazy"
            alt=""
            src="/2813821-1@2x.png"
          />
          <div className={styles.valuePropDetails}>
            Tackle the annoying task of setting a draft date by easily setting up polls.
          </div>
        </div>

        <div className={styles.valueProposition}>
          <div className={styles.valuePropositionChild} />
          <div className={styles.valueProp2Wrapper}>
            <h3 className={styles.valueProp2}>Prize tracker</h3>
          </div>
          <div className={styles.frameParent}>
            <div className={styles.detailPlaceholderWrapper}>
              <img
                className={styles.propositionTitleIcon}
                loading="lazy"
                alt=""
                src="/2813821-1@2x.png"
              />
            </div>
            <div className={styles.valuePropDetails}>
              Defend against confusion! Document league prizes and winners.
            </div>
          </div>
        </div>

        <div className={styles.valueProposition}>
          <div className={styles.valuePropositionChild} />
          <div className={styles.valueProp3Wrapper}>
            <h3 className={styles.valueProp3}>League rules</h3>
          </div>
          <div className={styles.wrapper}>
            <img
              className={styles.propositionTitleIcon}
              loading="lazy"
              alt=""
              src="/2813821-1@2x.png"
            />
          </div>
          <div className={styles.valuePropDetails}>
            Deflect all your league mates annoying questions by documenting and sharing your custom league rules.
          </div>
        </div>
      </div>
    </section>
  );
};

LandingProps.propTypes = {
  className: PropTypes.string,
};

export default LandingProps;
